import EditBreadCrumbs from './EditBreadCrumbs';

export default EditBreadCrumbs;
